<template>
    <div class="carboxylgruppe">
        <img
            src="@/assets/img/stoffe/carbon/carboxylgruppe.jpg"
            alt="Carboxylgruppe"
            title="Carboxylgruppe"
        />
    </div>
</template>

<script>
export default {
    name: 'carboxylgruppe',
};
</script>
